export default __webpack_public_path__ + "static/media/ic_rickshaw_block.0161aaf1.svg";